import { render, staticRenderFns } from "./DownloadProvider.vue?vue&type=template&id=70adbe55&"
import script from "./DownloadProvider.vue?vue&type=script&lang=js&"
export * from "./DownloadProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports